export const ACTIVE_FILTER_CHANGED = 'ACTIVE_FILTER_CHANGED'



// WEBPACK FOOTER //
// ./src/ui/active-filter/constants.js